import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorLoginService } from '../shared/services/vendor-login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vendorverifyotp',
  templateUrl: './vendorverifyotp.component.html',
  styleUrls: ['./vendorverifyotp.component.scss']
})
export class VendorverifyotpComponent implements OnInit, OnDestroy {
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  otpForm: FormGroup;
  mailId: string = '';
  isVerifying = false;
  errorMessage = '';
  countdown = 30;
  private countdownInterval: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private vendorLoginService: VendorLoginService,
    private toastr: ToastrService
  ) {
    this.otpForm = this.fb.group({
      digit0: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
      digit1: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
      digit2: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
      digit3: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
      digit4: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
      digit5: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]]
    });
  }

  ngOnInit(): void {
  // Get from queryParams
  this.route.queryParams.subscribe(params => {
    this.mailId = params['mailId'] || '';
    // If query param is missing, try navigation state
    if (!this.mailId) {
      const navigation = this.router.getCurrentNavigation();
      this.mailId = navigation?.extras?.state?.['mailId'] || '';
    }
    console.log("Final mailId:", this.mailId); 
  });

  this.startCountdown();
}



  ngAfterViewInit() {
    this.setupOtpInputFocus();
  }

  setupOtpInputFocus() {
    this.otpInputs.forEach((input, index) => {
      input.nativeElement.addEventListener('input', () => {
        if (input.nativeElement.value.length === 1 && index < 5) {
          this.otpInputs.toArray()[index + 1].nativeElement.focus();
        }
      });

      input.nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Backspace' && !input.nativeElement.value && index > 0) {
          this.otpInputs.toArray()[index - 1].nativeElement.focus();
        }
      });
    });
  }

  getOtpString(): string {
    return Object.values(this.otpForm.value).join('');
  }

  onSubmit() {
    if (this.otpForm.invalid) {
      this.errorMessage = 'Please enter a valid 6-digit OTP';
      return;
    }

    const payload = {
      mailId: this.mailId,
      otp: this.getOtpString()
    };

    this.isVerifying = true;
    this.errorMessage = '';

    this.vendorLoginService.vendorotpverification(payload).subscribe({
      next: (res: any) => {
        this.isVerifying = false;
        if (res) {
          this.toastr.success('OTP verified!');
          this.router.navigate(['/vendor-reset-password'], {
            queryParams: { mailId: this.mailId }
          });
        }
      },
      error: (err) => {
        this.isVerifying = false;
        this.errorMessage = err.error?.message || 'OTP verification failed';
      }
    });
  }

  moveCursor(currentIndex: number, event: any) {
    const input = event.target;
    const value = input.value;

    if (value.length === 1 && currentIndex < 5) {
      this.otpInputs.toArray()[currentIndex + 1].nativeElement.focus();
    }

    if (currentIndex === 5 && value.length === 1 && this.otpForm.valid) {
      this.onSubmit();
    }
  }

  resendOtp() {
    if (this.countdown > 0) return;

    this.vendorLoginService.vendorforgotpassword({ mailId: this.mailId }).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.countdown = 30;
          this.startCountdown();
          this.toastr.success('OTP resent!');
        }
      },
      error: (err) => {
        this.toastr.error(err.error?.message || 'Failed to resend OTP');
      }
    });
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}
